/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import Image from "next/image";
import React from "react";

export default function ImageComponent({ src, size, ...props }) {
  const IMAGE_SIZES = ["x", "s", "m", "l", "xl"];
  let _src = src;
  if (size && !IMAGE_SIZES.includes(size?.toString().toLowerCase())) {
    alert(`size: ${size} provided is invalid`);
  }
  if (src && String(src).indexOf("http") < 0) {
    _src = `${process.env.server_url_report}${src}?access_token=${
      process.env.public_token
    }&trustkey=${process.env.trustkey}${size ? `&size=${size}` : ""}`;
  }
  return <Image src={_src} alt="Hình ảnh sản phẩm" {...props} />;
}
